<template>
  <div class="col-auto mr-1 my-1">
    <form class="form-inline" @submit.prevent="submit" ref="customerSearchForm">
      <div class="input-group input-group-sm blah">
        <input class="form-control" style="height: 22px;" name="userInput" />
        <div class="input-group-append">
          <select class="btn am-btn-primary header-button" name="selection">
            <option id="select-dropdown" v-for="{value, text} in seekList" :value="value" :key="value">{{ text }}</option>
          </select>
        </div>
      </div>
      <button class="btn am-btn-primary btn-sm ml-1 header-button" type="submit">Search</button>
    </form>
  </div>
</template>

<script>
import config from '@/config/global.config'

export default {
  name: 'Headerbar',
  data: function () {
    return {
      ready: false,
      seekListPart1: [
        { value: 'Name', text: 'Name or ID' },
        { value: 'NameOnly', text: 'Name Only' },
        { value: 'ExactMatch', text: 'Exact Name Match' },
        { value: 'dob', text: 'Date of Birth' },
        { value: 'HHMember', text: 'Household Members' },
        { value: 'pfcn', text: 'PF Contract Number' },
        { value: 'Address', text: 'Address' },
        { value: 'Phone', text: 'Phone' },
        { value: 'DL', text: 'DL' },
        { value: 'Policy', text: 'Policy' },
        { value: 'VIN', text: 'VIN' },
        { value: 'Tag', text: 'Tag' }
      ],
      seekListPart3: [
        { value: 'Email', text: 'Customer Email' },
        { value: 'checkNumber', text: 'Check Number' },
        { value: 'source', text: 'Source' },
        { value: 'receiptDetail', text: 'ReceiptDetail ID' }
      ],
      seekListPart4Data: [
        { value: 'FirstName', text: 'First Name' },
        { value: 'LastName', text: 'Last Name' }
      ]
    }
  },
  computed: {
    seekList () {
      return (this.seekListPart1).concat(this.seekListPart2, this.seekListPart3, this.seekListPart4)
    },
    seekListPart2 () {
      return [
        { value: 'custom1', text: this.$store.state.auth.config.custom1label },
        { value: 'custom2', text: this.$store.state.auth.config.custom2label },
        { value: 'custom3', text: this.$store.state.auth.config.custom3label }
      ]
    },
    seekListPart4 () {
      if (this.$store.state.auth.config.showFirstNameLastName === 1) {
        return this.seekListPart4Data
      }
      return []
    }
  },
  methods: {
    submit () {
      let query = encodeURI(this.$refs.customerSearchForm.userInput.value)
      let selection = encodeURI(this.$refs.customerSearchForm.selection.value)
      window.location = `${config.appUrl}#/customer/search?selection=${selection}&query=${query}`
    }
  }
}
</script>
<style>
  .input-group-sm>.input-group-append>.btn {
    width: 89px;
    font-size: 12px;
    height: 22px;
    padding:2px;
    border-radius: 0px;

  }
  .input-group>.form-control:not(:last-child){
    border-radius: 0px;
  }

  .input-group-sm>.form-control {
    width: 180px;
  }
  #select-dropdown {
    background-color: white;
    color: black;
  }

</style>
